/** @format */

import React from "react";
import { Button } from "primereact/button";
import { showDeleteConfirmationDialog, setSelectedCommodity, showAddEditDialog } from "./commodityActions";

const ActionCellRenderer = (props) => {
  function startEditing() {
    props.dispatch(setSelectedCommodity({ ...props.data }));
    props.dispatch(showAddEditDialog(true));
  }

  function deleteRow() {
    props.dispatch(setSelectedCommodity({ ...props.data }));
    props.dispatch(showDeleteConfirmationDialog(true));
  }

  return props.isFromBarChart ? (
    <>
      {props.data.status === "A" ? (
        <Button type='button' className='btn3 m-0 p-0 userActionBtn' label='Hide' onClick={deleteRow} />
      ) : null}
      {props.data.status === "D" ? (
        <Button type='button' className='btn3 m-0 p-0 userActionBtn' label='Unhide' onClick={deleteRow} />
      ) : null}
    </>
  ) : (
    <>
      <Button className='p-button-rounded p-button-text' icon='pi pi-pencil' onClick={startEditing} />
      <Button className='p-button-rounded p-button-text' icon='pi pi-trash' onClick={deleteRow} />
    </>
  );
};

export default ActionCellRenderer;
